import { openBlock as a, createElementBlock as c, normalizeStyle as h, createElementVNode as u, createCommentVNode as m, normalizeClass as y } from "vue";
const z = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [r, n] of t)
    s[r] = n;
  return s;
}, S = [350, 550, 700, 800, 900], l = S.concat([1200, 2e3]), g = l, o = g.concat([3e3, 4e3]), d = (e = [], t = "", {
  isLowDensity: s = !1
} = {}) => e.reduce((r, n) => `${r}${t}?im=Resize,width=${n}${s ? "&density=1x" : ""} ${n}w,`, ""), f = {
  /* c8 ignore start */
  name: "ImageComponent",
  props: {
    images: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    useBannerCrop: {
      type: Boolean,
      required: !1,
      default: !1
    },
    ratio: {
      type: String,
      required: !1,
      default: ""
    },
    radius: {
      type: String,
      required: !1,
      default: ""
    },
    alt: {
      type: String,
      required: !1,
      default: ""
    },
    renderedSizes: {
      type: Object,
      required: !1,
      default: () => ({
        mobile: "100vw",
        desktop: "100vw"
      })
    },
    lazyLoad: {
      type: Boolean,
      required: !1,
      default: !0
    },
    fetchPriority: {
      type: String,
      required: !1,
      default: ""
    },
    customClasses: {
      type: String,
      required: !1,
      default: ""
    },
    ariaHidden: {
      type: String,
      required: !1,
      default: "false"
    },
    objectFit: {
      type: String,
      required: !1,
      default: "cover"
    },
    useResizing: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  computed: {
    cssVars() {
      return {
        "--ratio": this.ratio,
        "--object-fit": this.objectFit,
        "--radius": this.radius
      };
    },
    loading() {
      return this.lazyLoad && "lazy";
    },
    computedFetchPriority() {
      var e;
      return (e = this.fetchPriority) != null && e.length ? this.fetchPriority : null;
    },
    imageXs() {
      var s, r;
      const {
        vertical: e,
        original: t
      } = ((r = (s = this.images) == null ? void 0 : s.xs) == null ? void 0 : r.renditions) || {};
      return this.useBannerCrop && (e != null && e.src) ? e == null ? void 0 : e.src : t == null ? void 0 : t.src;
    },
    imageSm() {
      var s, r;
      const {
        vertical: e,
        original: t
      } = ((r = (s = this.images) == null ? void 0 : s.sm) == null ? void 0 : r.renditions) || {};
      return this.useBannerCrop && (e != null && e.src) ? e == null ? void 0 : e.src : t == null ? void 0 : t.src;
    },
    imageMd() {
      var s, r;
      const {
        horizontal: e,
        original: t
      } = ((r = (s = this.images) == null ? void 0 : s.md) == null ? void 0 : r.renditions) || {};
      return this.useBannerCrop && (e != null && e.src) ? e == null ? void 0 : e.src : t == null ? void 0 : t.src;
    },
    imageLg() {
      var s, r;
      const {
        horizontal: e,
        original: t
      } = ((r = (s = this.images) == null ? void 0 : s.lg) == null ? void 0 : r.renditions) || {};
      return this.useBannerCrop && (e != null && e.src) ? e == null ? void 0 : e.src : t == null ? void 0 : t.src;
    },
    xsSrcSet() {
      return this.useResizing ? d(S, this.imageXs) : this.imageXs;
    },
    smSrcSet() {
      return this.useResizing ? d(l, this.imageSm) : this.imageSm;
    },
    mdSrcSet() {
      return this.useResizing ? d(g, this.imageMd) : this.imageMd;
    },
    lgSrcSet() {
      return this.useResizing ? d(o, this.imageLg) : this.imageLg;
    },
    lowDensitySmSrcSet() {
      return this.useResizing ? d(l, this.imageSm, {
        isLowDensity: !0
      }) : this.imageSm;
    },
    lowDensityMdSrcSet() {
      return this.useResizing ? d(g, this.imageMd, {
        isLowDensity: !0
      }) : this.imageMd;
    },
    lowDensityLgSrcSet() {
      return this.useResizing ? d(o, this.imageLg, {
        isLowDensity: !0
      }) : this.imageLg;
    },
    renderedSizeMobile() {
      var e;
      return ((e = this.renderedSizes) == null ? void 0 : e.mobile) || "100vw";
    },
    renderedSizeDesktop() {
      var e;
      return ((e = this.renderedSizes) == null ? void 0 : e.desktop) || "100vw";
    },
    dprQuery() {
      return this.useResizing ? " and (-webkit-min-device-pixel-ratio: 1.5)" : "";
    }
  }
  /* c8 ignore end */
}, _ = ["media", "srcset", "sizes"], p = ["media", "srcset", "sizes"], w = ["media", "srcset", "sizes"], x = ["media", "srcset", "sizes"], b = ["srcset", "sizes"], k = ["srcset", "sizes"], L = ["srcset", "sizes"], R = ["alt", "src", "loading", "fetchpriority", "aria-hidden"];
function M(e, t, s, r, n, i) {
  return a(), c("picture", {
    "data-ui": "landing-image-component",
    class: "landing-image-component",
    style: h(i.cssVars)
  }, [u("source", {
    media: `(max-width: 767px)${i.dprQuery}`,
    srcset: i.xsSrcSet,
    sizes: i.renderedSizeMobile
  }, null, 8, _), u("source", {
    media: `(min-width: 1232px)${i.dprQuery}`,
    srcset: i.lgSrcSet,
    sizes: i.renderedSizeDesktop
  }, null, 8, p), u("source", {
    media: `(min-width: 992px)${i.dprQuery}`,
    srcset: i.mdSrcSet,
    sizes: i.renderedSizeMobile
  }, null, 8, w), u("source", {
    media: `(min-width: 768px)${i.dprQuery}`,
    srcset: i.smSrcSet,
    sizes: i.renderedSizeMobile
  }, null, 8, x), s.useResizing ? (a(), c("source", {
    key: 0,
    media: "(min-width: 1232px) and (-webkit-device-pixel-ratio: 1)",
    srcset: i.lowDensityLgSrcSet,
    sizes: i.renderedSizeDesktop
  }, null, 8, b)) : m("", !0), s.useResizing ? (a(), c("source", {
    key: 1,
    media: "(min-width: 992px) and (-webkit-device-pixel-ratio: 1)",
    srcset: i.lowDensityMdSrcSet,
    sizes: i.renderedSizeMobile
  }, null, 8, k)) : m("", !0), s.useResizing ? (a(), c("source", {
    key: 2,
    media: "(-webkit-device-pixel-ratio: 1)",
    srcset: i.lowDensitySmSrcSet,
    sizes: i.renderedSizeMobile
  }, null, 8, L)) : m("", !0), i.imageLg ? (a(), c("img", {
    key: 3,
    ref: "img",
    alt: s.alt,
    src: `${i.imageLg}`,
    loading: i.loading,
    fetchpriority: i.computedFetchPriority,
    class: y(["landing-image-component__image", s.customClasses]),
    "aria-hidden": s.ariaHidden
  }, null, 10, R)) : m("", !0)], 4);
}
const C = /* @__PURE__ */ z(f, [["render", M]]);
export {
  C as default
};
